// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__LVH9k","summary":"CartItem_summary__Tnqnq","price":"CartItem_price__357gG","amount":"CartItem_amount__blHLS","actions":"CartItem_actions__+KU12"};